import { RouteConfig } from 'vue-router'
import _ from 'lodash'

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'Login',
    meta: { title: 'login.title' },
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
  },
  {
    path: '/signup',
    name: 'Signup',
    meta: { title: 'signup.title' },
    component: () =>
      import(/* webpackChunkName: "signup" */ '@/views/Signup.vue'),
  },
  {
    path: '/signup/complete',
    name: 'SignupComplete',
    meta: { title: 'signupcomplete.title' },
    component: () =>
      import(
        /* webpackChunkName: "signup-complete" */ '@/views/SignupComplete.vue'
      ),
  },
  {
    path: '/signup/expired',
    name: 'SignupExpired',
    meta: { title: 'signupexpired.title' },
    component: () =>
      import(
        /* webpackChunkName: "signup-expired" */ '@/views/SignupExpired.vue'
      ),
  },
  {
    path: '/signup/invalid',
    name: 'SignupInvalid',
    meta: { title: 'signupinvalid.title' },
    component: () =>
      import(
        /* webpackChunkName: "signup-invalid" */ '@/views/SignupInvalid.vue'
      ),
  },
  {
    path: '/signup/alreadydone',
    name: 'SignupAlreadyDone',
    meta: { title: 'signupalreadydone.title' },
    component: () =>
      import(
        /* webpackChunkName: "signup-already-done" */ '@/views/SignupAlreadyDone.vue'
      ),
  },
  {
    path: '/store/signup',
    name: 'StoreSignup',
    meta: { title: 'storesignup.title' },
    component: () =>
      import(/* webpackChunkName: "store-signup" */ '@/views/StoreSignup.vue'),
  },
  {
    path: '/password/reset',
    name: 'ForgotPassword',
    component: () =>
      import(
        /* webpackChunkName: "forgotpassword" */ '@/views/ForgotPassword.vue'
      ),
    meta: { title: 'forgotpassword.title' },
  },
  {
    path: '/password/reset/:token',
    name: 'ResetPassword',
    component: () =>
      import(
        /* webpackChunkName: "resetpassword" */ '@/views/ResetPassword.vue'
      ),
    meta: { title: 'resetpassword.title' },
  },
  {
    path: '/terms/store-sales',
    name: 'TermsStoreSales',
    meta: { title: 'terms.storesales.title' },
    component: () =>
      import(
        /* webpackChunkName: "terms-store-sales" */ '@/views/TermsStoreSales.vue'
      ),
  },
  {
    path: '/terms/agent-sales',
    name: 'TermsAgentSales',
    meta: { title: 'terms.agentsales.title' },
    component: () =>
      import(
        /* webpackChunkName: "terms-agent-sales" */ '@/views/TermsAgentSales.vue'
      ),
  },
  {
    path: '/terms/agent-sales-tel-and-fax',
    name: 'TermsAgentSalesTelAndFax',
    meta: { title: 'terms.agentsalestelandfax.title' },
    component: () =>
      import(
        /* webpackChunkName: "terms-agent-sales" */ '@/views/TermsAgentSalesTelAndFax.vue'
      ),
  },
  {
    path: '/terms/affiliate',
    name: 'TermsAffiliate',
    meta: { title: 'terms.affiliate.title' },
    component: () =>
      import(
        /* webpackChunkName: "terms-affiliate" */ '@/views/TermsAffiliate.vue'
      ),
  },
  {
    path: '/commercial-transaction',
    name: 'CommercialTransaction',
    meta: { title: 'commercialtransaction.title' },
    component: () =>
      import(
        /* webpackChunkName: "commercialtransaction" */ '@/views/CommercialTransaction.vue'
      ),
  },
  {
    path: '/partner-signup',
    name: 'PartnerSignup',
    meta: { title: 'partnersignup.title' },
    component: () =>
      import(
        /* webpackChunkName: "partner-signup" */ '@/views/PartnerSignup.vue'
      ),
  },
]

export default routes.map((route) => {
  return _.merge({ meta: { private: false, layout: 'default' } }, route)
})
